module.exports = __webpack_public_path__ + "img/chat_code.d1a106e0.png";